module.exports = __webpack_public_path__ + "static/bearbath2-7fa7c5adb4a4cafbdd6a69623e27d482.png";